import { useWindowSize } from "@vueuse/core";

import { type VisibilityState } from "@tanstack/vue-table";

export const calcColumnDynamicSize = (
  ratio: number,
  totalColumns: number,
  columnVisibility: VisibilityState,
  pinnedColumns: string[] = [],
) => {
  const hiddenColumnsBaseCount = Object.values(columnVisibility).filter(
    (value) => !value,
  ).length;

  const hiddenColumnsCount = hiddenColumnsBaseCount - pinnedColumns.length;

  const { width } = useWindowSize();
  return (width.value - ratio) / (totalColumns - hiddenColumnsCount);
};
